import React from 'react';
import { Button, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { useHomeStrings } from '../../hooks/useHomeStrings';

interface Props {
  onBook: () => void;
}

export const UpcomingBookingEmpty: React.FC<Props> = ({ onBook }) => {
  const STRINGS = useHomeStrings();
  return (
  <div
    style={{
      margin: '0 16px 12px',
      borderRadius: 'var(--bl-radius-lg)',
      background: 'var(--bl-surface)',
      border: '1px solid var(--bl-divider)',
      padding: '20px 16px',
      textAlign: 'center',
    }}
  >
    <div
      style={{
        width: 44,
        height: 44,
        borderRadius: 12,
        background: 'var(--bl-divider)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 12px',
        fontSize: 20,
        color: 'var(--bl-primary)',
      }}
    >
      <CalendarOutlined />
    </div>
    <Typography.Text
      style={{
        display: 'block',
        fontWeight: 700,
        fontSize: 15,
        color: 'var(--bl-text)',
        marginBottom: 4,
      }}
    >
      {STRINGS.UPCOMING_EMPTY_TITLE}
    </Typography.Text>
    <Typography.Text
      style={{
        display: 'block',
        fontSize: 13,
        color: 'var(--bl-text-secondary)',
        marginBottom: 16,
      }}
    >
      {STRINGS.UPCOMING_EMPTY_DESC}
    </Typography.Text>
    <Button
      type="primary"
      block
      onClick={onBook}
      style={{
        height: 48,
        borderRadius: 'var(--bl-radius)',
        fontWeight: 600,
        fontSize: 15,
        border: 'none',
      }}
    >
      {STRINGS.BOOK_NOW}
    </Button>
  </div>
  );
};
